import React from "react";
import { default as WeekTimeRegistrations } from "components/Dashboard/Dashboard_WeekTimeRegistrations"
import { WIDGET_NAMES } from "components/WidgetTemplates/utils";
import { useTranslation } from "react-i18next";

const Card_WeekTimeRegistrations = (props) => {
	// console.log(props);
	const { t } = useTranslation();

	return (
		<article className="card card-week-chart">
			<div className="card-top">
				<h2>{t(WIDGET_NAMES[props.name])}</h2>
			</div>
			<div className="card-content">
				<WeekTimeRegistrations />
			</div>
		</article>
	);
};

export default Card_WeekTimeRegistrations;